import { defineMessages } from 'react-intl';

const scope = 'cb.screens';

export default defineMessages({
  privacy: {
    id: `${scope}.privacy`,
    defaultMessage: 'Enter referral code',
  },
  acceptBtn: {
    id: `${scope}.acceptBtn`,
    defaultMessage: 'Accept',
  },
  privacyPolicy: {
    id: `${scope}.privacy`,
    defaultMessage: 'Privacy policy',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  accept: {
    id: `${scope}.accept`,
    defaultMessage: 'Accept',
  },
});
